// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1Yf1g","label":"LabeledBox_label__2tCby"};